import React, { useState } from "react";
import {
  Button,
  Flex,
  Img,
  Input,
  Select,
  Stack,
  Text,
  Textarea,
  useColorModeValue,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Heading,
  Box,
} from "@chakra-ui/react";
import { checkout } from "./service";
import StripeForm from "../../../components/Stripe/StripeForm";
import { loadStripe } from "@stripe/stripe-js";
import { MdMessage } from "react-icons/md";
import { useNavigate } from "react-router-dom";

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const stripePublishKey = loadStripe(process.env.REACT_APP_STRIPE_KEY);

function GroupSliderInfo({ isOpen, onClose, groupData, handleSubmit, userInfo }) {
  const [clientSecret, setClientSecret] = useState("");
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const navigate = useNavigate();

  const containerBgColor = useColorModeValue("#F9FAFC", "#020b19");
  const inputBgColor = useColorModeValue("#fff", "#081b2e");

  const inputStyles = {
    p: "20px",
    borderRadius: "10px",
    boxShadow: "3px 8px 13px 0px #8080800f",
    bg: inputBgColor,
    w: "30%",
    color: "#697C94",
  };
  const handlePayment = async (groupId, plan) => {
    //console.log("plan: ", plan?.id);
    if ( groupData?.creator?.id == userInfo?.id ) return;

    const response = await checkout(groupId, plan?.id);
    let secretKey = response?.data?.client_secret;
    setClientSecret(secretKey);
    setSelectedPlan(plan);
    setShowPaymentForm(true);
    onClose(); // Close the groupModal
  };

  const handleJoinFreeGroup = async (groupType) => {
    await handleSubmit(groupType);
    gotoGroupChat(groupData)
    onClose();
  };

  // Function to generate a slug from text
  const slugify = (text) => {
    return text.toLowerCase().replace(/ /g, "-");
  };

  const slug = slugify(groupData?.name)
  //console.log('groupData: ', groupData);

  //store in state
  const gotoGroupChat = (groupData) => {
    navigate('/group', { state: { groupData: groupData } });
  }

  return (
    <>
      <Modal id="groupModal" isOpen={isOpen} onClose={onClose} size="lg">
        <ModalOverlay />
        <ModalContent bg={containerBgColor}>
          <ModalHeader></ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {/* Your filter settings content goes here */}
            <Flex justifyContent="space-between" alignItems="center" mb={"2em"}>
              <Stack>
                {/* Content for the left side */}
                <Flex alignItems="center">
                  <Img
                    src={groupData?.picture}
                    alt="Image Alt Text"
                    boxSize="50px" // Adjust the size as needed
                    borderRadius="50%" // Makes it round
                  />
                  <Box display={"block"} direction={"column"}>
                    <Text ml="2">{groupData?.name}</Text>

                    <Box ml="2" display={"none"}>
                      
                      <Text 
                        //size="xs"
                        cursor={"pointer"}
                        borderRadius={"5px"}
                        textAlign={"center"}
                        h="20px"
                        w="70px"
                        bg="#1391e67d"
                        _hover={{ background: "#1391e67d" }}
                        color="#fff"
                        boxShadow={"2px 2px 7px 0px #1391e67d"}
                        onClick={() => {
                          //navigate(`/edit-group/${slug}`)
                          navigate(`/groups/${slug}`, { state: { groupData: groupData } });
                        }}
                      >Edit</Text>

                      <Text
                        cursor={"pointer"} 
                        ml="2"
                        //size="xs"
                        borderRadius={"5px"}
                        textAlign={"center"}
                        h="20px"
                        w="70px"
                        bg="red"
                        _hover={{ background: "red" }}
                        color="#fff"
                        boxShadow={"2px 2px 7px 0px red"}
                      >Delete</Text>
                    </Box>
                     
                  </Box>
                  
                </Flex>
              </Stack>

              <Box>Owned by: {groupData?.creator?.username}</Box>
            </Flex>

            <Flex justifyContent="space-between">
              <Stack w={"65%"} mb={"2em"}>
                <Text textAlign="left">{groupData?.description}</Text>
              </Stack>

              {/* <MdMessage
                display={"none"}
                cursor={"pointer"}
                color="#7CD892"
                fontSize={"1.2em"}
                onClick={() => gotoGroupChat(groupData)}
              /> */}
            </Flex>
            
            {groupData?.type === "paid" && (
              <>
                <Stack mb={"2em"}>
                  <Flex justifyContent={"space-between"} alignItems="center">
                    <Heading fontSize={"1.5em"}>
                      Plans
                    </Heading>
                    {/* <MdMessage
                      cursor={"pointer"}
                      color="#7CD892"
                      fontSize={"1.2em"}
                    /> */}
                  </Flex>
                  <Text>
                    Choose your perfect subscription plan and pay easily
                  </Text>
                </Stack>

                {groupData?.plans?.length > 0 && (
                  <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    alignItems="center"
                    mb={"2em"}
                  >
                    {groupData?.plans?.map((plan) => (
                      <Box
                        direction={"column"}
                        key={plan?.id}
                        //cursor={"pointer"}
                        cursor={groupData?.creator?.id == userInfo?.id ? "default" : "pointer"}
                        {...inputStyles}
                        textAlign={"center"}
                        onClick={() => {
                          // Wrap the handlePayment logic inside a function
                          const handleClick = async () => {
                            await handlePayment(groupData?.id, plan);
                          };
                          handleClick(); // Call the function when clicked
                        }}
                      >
                        <Heading fontSize="1.2em">
                          {capitalizeFirstLetter(plan?.name)} Plan
                        </Heading>
                        <Text color={"#3CD561"} fontSize="0.9em">
                          ${plan?.price} / {capitalizeFirstLetter(plan?.name)}
                        </Text>
                      </Box>
                    ))}
                  </Stack>
                )}
              </>
            )}

            {groupData?.type === "free" && (
              <Stack>
                <Box
                  direction={"column"}
                  cursor={"pointer"}
                  {...inputStyles}
                  textAlign={"center"}
                  onClick={() => handleJoinFreeGroup(groupData?.type)}
                >
                  <Heading fontSize="1.2em">Free Group</Heading>
                  <Text color={"#3CD561"} fontSize="0.9em">
                    Free
                  </Text>
                </Box>
              </Stack>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal id="payModal" isOpen={showPaymentForm} onClose={() => null}>
        <ModalOverlay />
        <ModalContent>
          <ModalBody>
            <StripeForm
              clientSecret={clientSecret}
              stripePromise={stripePublishKey}
              groupName={groupData?.name}
              groupData={groupData}
              selectedPlan={selectedPlan}
              setShowPaymentForm={setShowPaymentForm}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default GroupSliderInfo;
